// Determines if date falls on or between a start and end date.
// Dates must formatted YYYY-MM-DD
export function inRange(date, start, end) {
  if (date === start) {
    return true;
  }
  if (end) {
    const formattedDate = new Date(date);
    const formattedStart = new Date(start);
    const formattedEnd = new Date(end);
    return formattedStart <= formattedDate && formattedEnd >= formattedDate;
  }
}
